class NotificacaoModalController {
    constructor(sce, modalInstance, notificacao, $scope, gql) {
        this.modalInstance = modalInstance
        this.notificacao = notificacao
        this.gql = gql

        this.trustAsHtml = function (string) {
            return sce.trustAsHtml(string);
        };

        this.apply = fn => $scope.$apply(fn)
    }

    $onInit() {
        this.promise = this
            .loadNotificacao()
            .then(notificacao => this.notificacao = notificacao)
            .finally(() => this.apply())
    }

    loadNotificacao() {
        const query = gql`
            query Notificacao($id: String!) {
                usuarioAtual {
                    id
                    notificacao(id: $id) {
                        id
                        tipo
                        titulo
                        temConteudoAdicional
                        conteudoAdicional
                        lida
                    }
                }
            }
        `

        return this.gql
            .query(query, { id: this.notificacao.id.toString() })
            .then(({usuarioAtual: {notificacao}}) => notificacao)
    }

    close() {
        this.modalInstance.dismiss()
    }
}

angular
    .module("eficienciaFiscalModule")
    .controller("notificacaoModalController", ["$sce", "$uibModalInstance", "notificacao", "$scope", "gql", NotificacaoModalController])
